module.exports = __webpack_public_path__ + "img/avatar-default.502b3c8b.png";